import { mockPushNotifications } from '@core/plugins/push-notifications/mock'
import { mockAppsflyer } from '@core/plugins/appsflyer/mock'
import { mockPlayInstallReferrer } from '@core/plugins/play-install-referrer/mock'
import type { PspType } from '@core/types/generated'

type Provider = {
  displayName: string
  type: PspType
  slug: string
  logo: {
    ico: string
    sm: string
  }
  score: { value: number } | null
}

export default defineNuxtPlugin(() => {
  try {
    return {
      provide: {
        getProviderFromSlug: (slug: string): Provider | undefined =>
          ({ displayName: slug }) as unknown as Provider,
        ...mockPushNotifications,
        ...mockAppsflyer,
        ...mockPlayInstallReferrer,
      },
    }
  } catch (e) {
    useLogger('plugin:mobile-plugin-mocks').error(e)
    throw e
  }
})
